// src/pages/Landing.jsx
import React from 'react';

export const Landing = () => {
  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-blue-50 to-white">
      {/* Header */}
      <header className="flex items-center justify-between p-6 shadow-sm bg-white">
        <div className="text-2xl font-bold text-blue-600">ZephyrDrive</div>
        <nav className="space-x-6">
          <a href="#features" className="text-gray-600 hover:text-blue-500 transition">
            Features
          </a>
          <a href="#pricing" className="text-gray-600 hover:text-blue-500 transition">
            Pricing
          </a>
          <a href="#about" className="text-gray-600 hover:text-blue-500 transition">
            About
          </a>
          <button className="ml-4 px-5 py-2 bg-blue-600 text-white rounded-full hover:bg-blue-700 transition">
            Get Started
          </button>
        </nav>
      </header>

      {/* Hero Section */}
      <section className="flex-1 flex flex-col items-center justify-center text-center px-6 py-20">
        <h1 className="text-4xl md:text-6xl font-bold text-gray-800 leading-tight mb-6">
          Your Cloud Storage, <br /> Reinvented.
        </h1>
        <p className="text-lg md:text-xl text-gray-600 mb-8 max-w-2xl">
          Secure, ultra-fast, and beautifully simple. Store, access, and share your files
          effortlessly with Zephyr Drive.
        </p>
        <div className="flex space-x-4">
          <button className="px-6 py-3 bg-blue-600 text-white rounded-full font-semibold hover:bg-blue-700 transition">
            Upload Now
          </button>
          <button className="px-6 py-3 border border-blue-600 text-blue-600 rounded-full font-semibold hover:bg-blue-50 transition">
            Learn More
          </button>
        </div>
      </section>

      {/* Features Section */}
      <section id="features" className="py-20 bg-gray-50">
        <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-3 gap-10 text-center">
          <div>
            <div className="text-blue-600 text-4xl mb-4">☁️</div>
            <h3 className="text-xl font-bold mb-2">Unlimited Storage</h3>
            <p className="text-gray-600">
              No more worrying about space. Upload as much as you need, anytime.
            </p>
          </div>
          <div>
            <div className="text-blue-600 text-4xl mb-4">🔒</div>
            <h3 className="text-xl font-bold mb-2">Bank-level Security</h3>
            <p className="text-gray-600">
              Your files are encrypted and safely backed up across multiple regions.
            </p>
          </div>
          <div>
            <div className="text-blue-600 text-4xl mb-4">🚀</div>
            <h3 className="text-xl font-bold mb-2">Blazing Fast</h3>
            <p className="text-gray-600">
              Experience ultra-fast uploads and downloads, powered by our global network.
            </p>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-8 text-center text-gray-500 text-sm">
        © {new Date().getFullYear()} ZephyrDrive. All rights reserved.
      </footer>
    </div>
  );
};

export default Landing;
